import { useQuery, QueryClient } from 'react-query';
import { getPrivateApi } from '../../../../services/api';
import type { CustomUseQueryOptions } from '../../requests-types/custom-use-query-options';
import { useActivatedIntegration } from '../../../use-activated-integration';
import { INTEGRATION_PROVIDERS } from '@vy/types';
import type { PaddleGetProductsResponse } from '@vy/api-definition';
import { queryKeys } from '../../../../services/query-key/query-keys';

async function paddleProductsQuery() {
  const api = getPrivateApi();
  const response = await api.paddleGetProducts();

  return response;
}

export function usePaddleProducts(options?: CustomUseQueryOptions<PaddleGetProductsResponse>) {
  const isPaddleActivated = useActivatedIntegration(INTEGRATION_PROVIDERS.paddle);

  return useQuery(queryKeys.paddleProducts(), () => paddleProductsQuery(), {
    ...options,
    enabled: isPaddleActivated,
  });
}

export function prefetchPaddleProducts(queryClient: QueryClient) {
  return queryClient.prefetchQuery(queryKeys.paddleProducts(), () => paddleProductsQuery());
}
